<template>
  <d-card class="card-small blog-comments tier-card">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }}</h6>
    </d-card-header>
    <figure class="scroll">
      <d-card-body class="p-0">
        <div
          v-for="(activity, index) in tierActivities.slice(0, 10)"
          :key="index"
          class="blog-comments__item d-flex p-3"
        >
          <!-- Avatar -->
        <!--   <div class="blog-comments__avatar mr-3">
           <img
              src="../../assets/images/avatars/1.jpg"
              :alt="activity.supporter.name"
            />
          </div>-->

          <!-- Content -->
          <div class="blog-comments__content">
            <!-- Content - Title -->
            <div class="blog-comments__meta text-muted">
              <a class="text-secondary" href="#">{{ activity.supporter.name }}</a>
              completed tier
              <template v-if="activity.action && !activity.tier">
                <a class="text-secondary" href="#"
                  >action
                  <strong>{{ activity.action.title }}</strong>
                </a>
                <br />
                <span class="text-muted"
                  >– {{ new Date(activity.createdAt) | moment("from") }}</span
                >
              </template>
              <template v-if="activity.tier">
                <a class="text-secondary" v-if="activity.tier" href="#">
                  <strong>{{ activity.tier.name }}</strong>
                </a>
                <span class="text-muted"
                  >– {{ new Date(activity.createdAt) | moment("from") }}</span
                >
              </template>
            </div>
            <!-- Content - Actions -->
          </div>
        </div>
      </d-card-body>
    </figure>
  </d-card>
</template>

<script>
const defaultDiscussionsData = [
  {
    id: 1,
    date: "3 days ago",
    author: {
      image: require("@/assets/images/avatars/1.jpg"),
      name: "John Doe",
      url: "#"
    },
    post: {
      title: "Hello World!",
      url: "#"
    },
    body: "Well, the way they make shows is, they make one show ..."
  },
  {
    id: 2,
    date: "4 days ago",
    author: {
      image: require("@/assets/images/avatars/2.jpg"),
      name: "John Doe",
      url: "#"
    },
    post: {
      title: "Hello World!",
      url: "#"
    },
    body: "After the avalanche, it took us a week to climb out. Now..."
  },
  {
    id: 3,
    date: "5 days ago",
    author: {
      image: require("@/assets/images/avatars/3.jpg"),
      name: "John Doe",
      url: "#"
    },
    post: {
      title: "Hello World!",
      url: "#"
    },
    body: "After the avalanche, it took us a week to climb out. Now..."
  },
  {
    id: 4,
    date: "5 days ago",
    author: {
      image: require("@/assets/images/avatars/3.jpg"),
      name: "John Doe",
      url: "#"
    },
    post: {
      title: "Hello World!",
      url: "#"
    },
    body: "After the avalanche, it took us a week to climb out. Now..."
  },
  {
    id: 5,
    date: "5 days ago",
    author: {
      image: require("@/assets/images/avatars/3.jpg"),
      name: "John Doe",
      url: "#"
    },
    post: {
      title: "Hello World!",
      url: "#"
    },
    body: "My money's in that office, right? If she start giving me..."
  }
];

export default {
  name: "discussions",
  props: {
    /**
     * The component's title.
     */
    tierActivities: {
      type: Array,
      default() {
        return [];
      }
    },
    title: {
      type: String,
      default: "Recent Tiers Activity"
    },
    /**
     * The discussions data.
     */
    discussionsData: {
      type: Array,
      default() {
        return defaultDiscussionsData;
      }
    }
  },
  watch: {
    tierActivities(tier) {
    }
  },
  methods: {
    /**
     * Emits an action and passes the discussions' ID for reference.
     * @param  {String} action The action type. One of: approve,reject,edit,view-all-comments
     */
    handleClick(action, id) {
      this.$emit(action, id);
    }
  }
};
</script>
<style lang="scss" scope>
.scroll {
  max-height: 384px;
  overflow-x: auto;
}
.action-card {
  min-height: 384px;
}
</style>
